export default __webpack_public_path__ + "b78351344d06d042c9d79f818d91c68d.svg";